import { ArrowUpRight, Cpu, Globe2, Network } from "lucide-react";

const icons = [Globe2, Cpu, Network];

export function PhisonPartnership({ content, images = [] }) {
  return (
    <>
      <section id="phison" className="section phison-section phison-intro-section" data-testid="phison-section">
        <div className="slide-split">
          <div className="section-heading wide">
            <p className="overline" data-testid="phison-overline">{content.overline}</p>
            <h2 data-testid="phison-title">{content.title}</h2>
            <p data-testid="phison-description">{content.description}</p>
          </div>
          <div className="deck-image-panel" data-testid="phison-image-panel-1">
            {images[0]?.image ? <img src={images[0].image} alt={content.title} data-testid="phison-image-1" /> : <span>{content.stats?.[1] || content.overline}</span>}
          </div>
        </div>

        <div className="phison-stat-strip" data-testid="phison-stat-strip">
          {(content.stats || []).map((stat, index) => (
            <span key={stat} data-testid={`phison-stat-${index + 1}`}>{stat}</span>
          ))}
        </div>
      </section>

      <section className="section phison-section phison-points-section" data-testid="phison-points-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="phison-points-overline">{content.overline}</p>
          <h2 data-testid="phison-points-title">{content.stats?.[3] || content.title}</h2>
        </div>

        {images[1]?.image ? (
          <div className="deck-strip-image" data-testid="phison-image-panel-2">
            <img src={images[1].image} alt={content.overline} data-testid="phison-image-2" />
          </div>
        ) : null}

        <div className="phison-brief-grid" data-testid="phison-brief-grid">
          {(content.points || []).map((point, index) => {
            const Icon = icons[index] || ArrowUpRight;
            return (
              <article className="phison-card" key={point.title} data-testid={`phison-point-${index + 1}`}>
                <div className="solution-icon" data-testid={`phison-point-icon-${index + 1}`}>
                  <Icon size={24} aria-hidden="true" />
                </div>
                <h3 data-testid={`phison-point-title-${index + 1}`}>{point.title}</h3>
                <p data-testid={`phison-point-text-${index + 1}`}>{point.text}</p>
              </article>
            );
          })}
        </div>
      </section>
    </>
  );
}